import { Typography } from "@material-ui/core";
import { FunctionComponent } from "react";
import StandardModal from "./StandardModal";
import ModalSize from "./ModalSize";
import { closeInformationModal } from "./InformationModalReducer";

interface ScreenProps {
  title: string;
  onOk: () => void;
  open: boolean;
  modalSize?: ModalSize;
}

const InformationModal: FunctionComponent<ScreenProps> = props => {
  return (
    <StandardModal
      size={props.modalSize ?? ModalSize.medium}
      open={props.open}
      title={props.title}
      onSubmit={props.onOk}
      cancelClose={closeInformationModal}
    >
      <div className="mainBody">
        <Typography className="helperText" variant="subtitle1">
          {props.children}
        </Typography>
      </div>
    </StandardModal>
  );
};

export default InformationModal;
